import React from 'react';
import PropTypes from 'prop-types';

import {Box} from "@mui/material";

import {grey600, greyishBlue50, greyishBlue500} from "assets/jss/main";

import {UserAgentUtils} from "utils/useragent";

ProductImage.propTypes = {
    rank: PropTypes.number,
    image: PropTypes.string,
    name: PropTypes.string,
};


const isMobile = UserAgentUtils.isMobile();

const commonStyles = {
    width: isMobile ? 56 : 72,
    height: isMobile ? 72 : 96,
    objectFit: "cover",
    borderRadius: "8px",
    border: isMobile ? 'none' : `1px solid ${grey600}`,
    flexShrink: 0,
    backgroundColor: isMobile ? 'none' :greyishBlue50,
}

function ProductImage({rank, image, name}) {
    return (
        <Box sx={{display: "flex", alignItems: "center", gap: "4px"}}>
            {rank &&  (
                <div style={{
                    color: greyishBlue500,
                    fontSize: "14px",
                    fontWeight: 600,
                    width: "20px",
                    textAlign: "center",
                    flexShrink: 0,
                    ...isMobile && {
                        alignSelf: 'baseline'
                    }
                }}>
                    {rank}
                </div>
            )}
            {image ? (
                <Box
                    component="img"
                    src={image}
                    alt={name}
                    sx={commonStyles}
                />
            ) : (
                <Box sx={commonStyles} />
            )}
        </Box>
    );
}

export default ProductImage;
